import { render, staticRenderFns } from "./WidgetsInput.vue?vue&type=template&id=3b07b712&scoped=true&"
import script from "./WidgetsInput.vue?vue&type=script&lang=js&"
export * from "./WidgetsInput.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsInput.vue?vue&type=style&index=0&id=3b07b712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b07b712",
  null
  
)

export default component.exports